export const leftAnimation = {
  hidden: {
    x: -100,
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
  },
};

export const rightAnimation = {
  hidden: {
    x: +100,
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
  },
};
